import { Stack, Tooltip, Typography } from '@mui/material'
import capitalize from 'lodash/capitalize'
import { useTranslation } from 'react-i18next'
import { Request } from '@omnea-app/requests/requestsHttpClient'
import { RequestPriorityIcon } from './RequestPriorityIcon'
import { requestPriorityEnumToNumberMap } from './utils'

const TOTAL_REQUEST_ICONS = 5
const getFormattedRequestPriorityString = (priority: Request['derivedFields']['priority']) => capitalize(priority)

export interface Props {
  priority: Request['derivedFields']['priority']
  displayTitle?: boolean
  displayFormattedPriorityString?: boolean
  displayTooltip?: boolean
}

export const RequestPriority = ({ priority, displayTitle, displayFormattedPriorityString, displayTooltip }: Props) => {
  const { t } = useTranslation('requests')
  const coloredRequestPriorityIcons = requestPriorityEnumToNumberMap[priority]
  const uncoloredRequestPriorityIcons = TOTAL_REQUEST_ICONS - coloredRequestPriorityIcons
  const formattedPriorityString = getFormattedRequestPriorityString(priority)

  return (
    <Tooltip title={displayTooltip && t('priority.tooltip', { priority: formattedPriorityString })}>
      <Stack gap={2}>
        {displayTitle && (
          <Typography variant="HeaderSubtitleXSmallRegular" color="neutralLight.900">
            {t('priority.main')}
          </Typography>
        )}
        <Stack direction="row" gap={2} sx={{ alignItems: 'center' }}>
          <Stack direction="row" gap={1}>
            {[...Array(coloredRequestPriorityIcons)].map((_, i) => {
              return <RequestPriorityIcon key={i} priority={priority} />
            })}
            {uncoloredRequestPriorityIcons > 0 &&
              [...Array(uncoloredRequestPriorityIcons)].map((_, i) => {
                return <RequestPriorityIcon key={i} />
              })}
          </Stack>
          {displayFormattedPriorityString && (
            <Typography variant="HeaderSubtitleMediumRegular" color="neutralDark.300">
              {formattedPriorityString}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Tooltip>
  )
}
